import axios from 'axios';
import get from 'lodash/get';

import actionTypes from './actionTypes';
import store from '../store/store';

import formatProjectAddBody from '../../helpers/formatProjectAddBody';
import formatProjectUpdateBody from '../../helpers/formatProjectUpdateBody';
import formatProductAddBody from '../../helpers/formatProductAddBody';
import formatProductEditBody from '../../helpers/formatProductEditBody';
import formatFaqCatAddBody from '../../helpers/formatFaqCatAddBody';
import formatFaqCatUpdateBody from '../../helpers/formatFaqCatUpdateBody';
import formatFaqAddBody from '../../helpers/formatFaqAddBody';
import formatFaqUpdateBody from '../../helpers/formatFaqUpdateBody';

import { API_CONFIG } from '../../config/api.config';
import { downloadFile } from '../../helpers/donwloadFile';
import { routes } from '../../constants';

const createHeaders = () => {
	const state = store.getState();
	const langTag = state.head.language.toUpperCase();
	const lang = state.head.utilities.languages.find(lng => lng.tag === langTag) || '489d6ac3-7b65-42c1-bdc6-67348bf7a112';
	const token = state.cms.authentication.token || localStorage.getItem('token');

	return { headers: { lang, token } };
};

export const validateForm = () => (dispatch) => {
	const form = { ...store.getState().cms.form };
	let valid = true;

	for (const key in form) {
		if (form[key].required && !form[key].valid) {
			valid = false;
		}
	}

	dispatch({
		type: actionTypes.VALIDATE_FORM,
		valid,
	});
};

export const uploadInProgress = () => (dispatch) => {
	dispatch({
		type: actionTypes.UPLOADING_IN_PROGRESS,
	});
};
export const uploadingFailed = () => (dispatch) => {
	dispatch({
		type: actionTypes.UPLOADING_FAILED,
	});
};
export const uploadingSucceeded = () => (dispatch) => {
	dispatch({
		type: actionTypes.UPLOADING_SUCCEEDED,
	});
};

export const uploadPoFile = ({ file, language }) => (dispatch) => {
	const head = createHeaders();
	const body = new FormData();
	body.append('file', file);

	(dispatch(uploadInProgress()));

	axios.put(`${API_CONFIG.ROUTE}${API_CONFIG.TRANSLATION}/${language}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.UPLOAD_PO_FILE,
	});
};

export const downloadPoFile = ({ language }) => (dispatch) => {
	const head = createHeaders();
	const state = store.getState();
	const tag = state.head.utilities.languages.find(lng => lng.uuid === language).tag.toLowerCase();

	(dispatch(uploadInProgress()));

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.TRANSLATION}/${language}/download`, head)
		.then((result) => {
			downloadFile({ file: result.data, fileName: `translation_${tag}.po` });
			(dispatch(uploadingSucceeded()));
		})
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.DOWNLOAD_PO_FILE,
	});
};

export const initForm = ({ fields, values = {} }) => (dispatch) => {
	const form = fields.reduce((prev, field) => {
		const value = get(values, `${field.field}`, undefined);
		const valid = !(value === [] || value === '' || value === undefined);
		const accumulator = { ...prev };

		accumulator[field.field] = { value, valid, required: field.required };

		return accumulator;
	}, {});


	dispatch({
		type: actionTypes.INIT_FORM,
		form,
	});

	dispatch(validateForm());
};

export const updateForm = ({ key, value, valid }) => (dispatch) => {
	const val = key.includes('-slug') ? value.replace(/ |\//g, '_') : value;

	dispatch({
		type: actionTypes.UPDATE_FORM,
		key,
		value: {
			value: val,
			valid,
		},
	});

	dispatch(validateForm());
};

const convertForm = () => {
	const state = store.getState().cms.form;
	const body = {};

	Object.keys(state).forEach((key) => {
		body[key] = state[key].value;
	});

	return body;
};

const convertFormToFormData = () => {
	const state = store.getState().cms.form;
	const body = new FormData();

	Object.keys(state).forEach((key) => {
		body.append(key, state[key].value);
	});

	return body;
};

// ADD ACTIONS

export const addProduct = history => (dispatch) => {
	const form = convertForm();
	const body = formatProductAddBody({
		form,
		languages: store.getState().head.utilities.languages,
		products: store.getState().product.result,
		projects: store.getState().content.projects.result,
		atex: store.getState().content.atex,
		productCategories: store.getState().content.category,
		price: store.getState().content.price,
		webshop: store.getState().content.webshop,
	});
	const head = createHeaders();


	(dispatch(uploadInProgress()));

	axios.post(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.PRODUCTS}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.ADD_PRODUCT,
	});
};
export const addDocument = history => (dispatch) => {
	const body = convertFormToFormData();
	const head = createHeaders();

	const state = store.getState().cms.form;
	body.append('imageUuid', state.image.value.uuid);


	(dispatch(uploadInProgress()));
	axios.post(`${API_CONFIG.ROUTE}${API_CONFIG.DOCUMENT}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.DOCUMENTS}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.ADD_DOCUMENT,
	});
};
export const addProject = history => (dispatch) => {
	const form = convertForm();
	const body = formatProjectAddBody(form, store.getState().head.utilities.languages);
	const head = createHeaders();

	(dispatch(uploadInProgress()));

	axios.post(`${API_CONFIG.ROUTE}${API_CONFIG.PROJECT}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.PROJECTS}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.ADD_PROJECT,
	});
};
export const addReference = history => (dispatch) => {
	const body = convertForm();
	const head = createHeaders();
	(dispatch(uploadInProgress()));

	const state = store.getState().cms.form;
	body.imageUuid = state.featuredImage.value.uuid;

	axios.post(`${API_CONFIG.ROUTE}${API_CONFIG.REFERENCE}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.REFERENCE}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.ADD_REFERENCE,
	});
};
export const addUser = history => (dispatch) => {
	const body = convertForm();
	const head = createHeaders();
	(dispatch(uploadInProgress()));

	axios.post(`${API_CONFIG.ROUTE}${API_CONFIG.USER}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.USERS}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.ADD_USER,
	});
};

export const addFaq = history => (dispatch) => {
	const form = convertForm();
	const body = formatFaqCatAddBody(form, store.getState().head.utilities.languages);
	const head = createHeaders();
	(dispatch(uploadInProgress()));


	axios.post(`${API_CONFIG.ROUTE}${API_CONFIG.FAQ}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.FAQ}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.ADD_FAQ,
	});
};
export const addFaqItem = history => (dispatch) => {
	const form = convertForm();
	const body = formatFaqAddBody(form, store.getState().head.utilities.languages);
	const head = createHeaders();
	(dispatch(uploadInProgress()));
	const faqCatId = store.getState().content.faq.find(f => f.uuid === form[`${store.getState().head.utilities.languages[0].uuid}-faqcategoryUuid`]).id;

	axios.post(`${API_CONFIG.ROUTE}${API_CONFIG.FAQ_ITEM}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.CREATE_FAQ_SECTION}/${faqCatId}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.ADD_FAQ,
	});
};
// UPDATE ACTIONS

export const updateProduct = history => (dispatch) => {
	const form = convertForm();
	const body = formatProductEditBody({
		form,
		languages: store.getState().head.utilities.languages,
		products: store.getState().product.result,
		projects: store.getState().content.projects.result,
		atex: store.getState().content.atex,
		productCategories: store.getState().content.category,
	});
	const head = createHeaders();
	(dispatch(uploadInProgress()));

	axios.put(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.PRODUCTS}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.UPDATE_PRODUCT,
	});
};
export const updateDocument = history => (dispatch) => {
	const body = convertFormToFormData();
	const head = createHeaders();

	const state = store.getState().cms.form;

	if (state.image && state.image.value && state.image.value.uuid) {
		body.append('imageUuid', state.image.value.uuid);
	}

	(dispatch(uploadInProgress()));

	axios.put(`${API_CONFIG.ROUTE}${API_CONFIG.DOCUMENT}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.DOCUMENTS}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.UPDATE_DOCUMENT,
	});
};
export const updateProject = history => (dispatch) => {
	const form = convertForm();
	const body = formatProjectUpdateBody(form, store.getState().head.utilities.languages);
	const head = createHeaders();
	(dispatch(uploadInProgress()));

	axios.put(`${API_CONFIG.ROUTE}${API_CONFIG.PROJECT}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.PROJECTS}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.UPDATE_PROJECT,
	});
};
export const updateReference = history => (dispatch) => {
	const body = convertForm();
	const head = createHeaders();
	(dispatch(uploadInProgress()));

	const state = store.getState().cms.form;
	body.imageUuid = state.featuredImage.value.uuid;

	axios.put(`${API_CONFIG.ROUTE}${API_CONFIG.REFERENCE}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.REFERENCE}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.UPDATE_REFERENCE,
	});
};
export const updateUser = history => (dispatch) => {
	const body = convertForm();
	const head = createHeaders();
	(dispatch(uploadInProgress()));

	axios.put(`${API_CONFIG.ROUTE}${API_CONFIG.USER}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.USERS}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.UPDATE_USER,
	});
};
export const updateFaq = history => (dispatch) => {
	const form = convertForm();
	const body = formatFaqCatUpdateBody(form, store.getState().head.utilities.languages);
	const head = createHeaders();
	(dispatch(uploadInProgress()));

	axios.put(`${API_CONFIG.ROUTE}${API_CONFIG.FAQ}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.FAQ}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.UPDATE_FAQ,
	});
};

export const updateFaqItem = history => (dispatch) => {
	const form = convertForm();
	const body = formatFaqUpdateBody(form, store.getState().head.utilities.languages);
	const head = createHeaders();
	(dispatch(uploadInProgress()));
	const faqCatId = store.getState().content.faq.find(f => f.uuid === form[`${store.getState().head.utilities.languages[0].uuid}-faqcategoryUuid`]).id;

	axios.put(`${API_CONFIG.ROUTE}${API_CONFIG.FAQ_ITEM}`, body, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => history.push(`${routes.CMS.DEFAULT}${routes.CMS.CREATE_FAQ_SECTION}/${faqCatId}`))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.UPDATE_FAQ,
	});
};

// REMOVE ACTIONS

export const removeProduct = id => (dispatch) => {
	const head = createHeaders();
	(dispatch(uploadInProgress()));

	axios.delete(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT}/${id}`, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => dispatch({
			type: actionTypes.REMOVE_PRODUCT,
			id,
		}))
		.catch(() => (dispatch(uploadingFailed())));
};
export const removeDocument = id => (dispatch) => {
	(dispatch(uploadInProgress()));
	const head = createHeaders();
	axios.delete(`${API_CONFIG.ROUTE}${API_CONFIG.DOCUMENT}/${id}`, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => dispatch({
			type: actionTypes.REMOVE_DOCUMENT,
			id,
		}))
		.catch(() => (dispatch(uploadingFailed())));
};
export const removeProject = id => (dispatch) => {
	const head = createHeaders();
	(dispatch(uploadInProgress()));

	axios.delete(`${API_CONFIG.ROUTE}${API_CONFIG.PROJECT}/${id}`, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => dispatch({
			type: actionTypes.REMOVE_PROJECT,
			id,
		}))
		.catch(() => (dispatch(uploadingFailed())));
};
export const removeReference = id => (dispatch) => {
	const head = createHeaders();
	(dispatch(uploadInProgress()));

	axios.delete(`${API_CONFIG.ROUTE}${API_CONFIG.REFERENCE}/${id}`, head)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => dispatch({
			type: actionTypes.REMOVE_REFERENCE,
			id,
		}))
		.catch(() => (dispatch(uploadingFailed())));
};
export const removeUser = id => (dispatch) => {
	const header = createHeaders();
	(dispatch(uploadInProgress()));

	axios.delete(`${API_CONFIG.ROUTE}${API_CONFIG.USER}/${id}`, header)
		.then(() => (dispatch(uploadingSucceeded())))
		.catch(() => (dispatch(uploadingFailed())));

	dispatch({
		type: actionTypes.REMOVE_USER,
	});
};

export const removeFAQ = id => (dispatch) => {
	const header = createHeaders();
	(dispatch(uploadInProgress()));

	axios.delete(`${API_CONFIG.ROUTE}${API_CONFIG.FAQ}/${id}`, header)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => dispatch({
			type: actionTypes.REMOVE_FAQ,
			id,
		}))
		.catch(() => (dispatch(uploadingFailed())));
	dispatch({
		type: actionTypes.REMOVE_USER,
	});
};

export const removeFAQItem = id => (dispatch) => {
	const header = createHeaders();
	(dispatch(uploadInProgress()));

	axios.delete(`${API_CONFIG.ROUTE}${API_CONFIG.FAQ_ITEM}/${id}`, header)
		.then(() => (dispatch(uploadingSucceeded())))
		.then(() => dispatch({
			type: actionTypes.REMOVE_FAQ_ITEM,
			id,
		}))
		.catch(() => (dispatch(uploadingFailed())));
	dispatch({
		type: actionTypes.REMOVE_USER,
	});
};

export const login = ({ username, password }) => (dispatch) => {
	(dispatch(uploadInProgress()));

	const body = { username, password };

	axios.post(`${API_CONFIG.ROUTE}${API_CONFIG.AUTH}`, body)
		.then((res) => {
			dispatch(uploadingSucceeded());
			localStorage.setItem('token', res.data.token);
			dispatch({
				type: actionTypes.SET_TOKEN,
				token: res.data.token,
			});
		})
		.catch(() => {
			dispatch(uploadingFailed());
			dispatch({
				type: actionTypes.LOG_IN_FAILED,
			});
		});

	dispatch({
		type: actionTypes.LOG_IN,
	});
};

export const logOut = () => (dispatch) => {
	localStorage.removeItem('token');

	dispatch({
		type: actionTypes.LOG_OUT,
	});
};

export const checkCMSAccess = () => (dispatch) => {
	dispatch({
		type: actionTypes.CHECK_CMS_ACCESS,
	});
};



// WEBPACK FOOTER //
// ./src/redux/cms/cmsActions.js